import type { ComputedRef, InjectionKey, Ref } from "vue";
import type { CellGroupsPostPayload } from "@/types/api";

export interface ReportReviewContext {
  isBusy: Ref<boolean>;
  isReviewed: Ref<boolean>;
  slideInfo: Ref<Record<string, unknown>>;
  cellBackendRequestObj: ComputedRef<unknown>;
  postCells: (payload: CellGroupsPostPayload) => Promise<void>;
  save: () => Promise<void>;
  resetState: () => void;
}

export type ProvidedReportReviewContext =
  | ReportReviewContext
  | Readonly<Ref<ReportReviewContext>>;

export const reportReviewInjectionKey: InjectionKey<ProvidedReportReviewContext> = Symbol(
  "blade.reportReviewContext",
);
